export const en = {
  // CYCLES
  cycles: {
    cycles: [
      "STRUCTURAL COLLAGE",
      "INTERIOR",
      "EGG DOMINATION",
      "SCULPTURE",
      //"POETRY",
      "OTHER",
    ],
  },

  // ERROR
  error: {
    errorHeader: "Page not found",
    errorButton: "Back to main page",
  },

  // GDPR
  cookieBanner: {
    cookieBannerParagraph:
      "We use cookies to improve your experience on this site. By continuing, you accept our privacy policy.",
    cookieBannerLink: "More Details",
    cookieBannerButton: "Agree",
  },

  // MENU
  menu: {
    menuButton: "MENU",
    closeMenuButton: "CLOSE",
    artworksMenuButton: "Artworks",
    exhibitionsMenuButton: "Exhibitions",
    biographyMenuButton: "About me",
    contactMenuButton: "Contact",
    backToMainPage: "Back",
    backToExhibitionsPage: "Back to exhibitions",
    backToCyclesPage: "Back to cycles",
  },

  poetry: {
    poetryHeader: "Poetry",
  },

  artworks: {
    "0082": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0081": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0080": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0079": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0078": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0077": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0076": {
      artworkAvailability: "SOLD",
      artworkDescription: `
        Nonagon (Nona, 9, nine-pointed)
        9 symbolic meanings:
        1. Numerological (mathematical)
        Four sides of the lower base + four sides of the upper base + the point of elevation fist (total 9 focus points). 9 arms.
        2. Symbolic (transformational)
        One of the oldest associations associated with the number 9 is the idea of ending one cycle and beginning a new cycle, in this context the number 9 suggests that after a period of change and transformation something new, exciting is coming.
        3. Evolutionary
        9 is often seen as a number representing personal development. It suggests that after experiences we reach a higher level of consciousness, elevation, evolution. Devoid of stereotypes, accepted patterns, or dogmas.
        4. Magical
        Due to its deep symbolic meaning, the number 9 was associated with magic. 9 was considered a mystical number, opening doors to unknown portals.
        5. Metaphysical
        In Norse mythology and others, the world is divided into 9 different levels of existence, the 9 arms symbolize the connection with different dimensions of reality.
        6. Artistic
        In reference to the 9 muses of Greek mythology, the 9 arms refer to 9 artistic elements.
        7. Confrontational (spiritual)
        Placing certain sacred things in an artistic approach and depriving them of certain dogmas forces us to look at it from a different point of view and confront the drugs that appear with the new mutated, modified reality.
        8. Euphoric (encoded)
        body, mind, euphoria.
        9. Raised hand with a clenched fist = 9`,
    },

    "0075": {
      artworkAvailability: "AVAILABLE",
      artworkDescription:
        "We are all one. The world and all living beings, originating from the same elements, atoms, microparticles, only find themselves in their own point of concentration. Not only at the level of atoms and we are one, but our bodies and beings can have existence, even if they come from different species or forms of existence. It is external that the boundaries between organisms are more conventional than we think and makes us all earthly beings equal to each other.",
    },

    "0074": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0073": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0072": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0071": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0070": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0069": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0068": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0067": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    /*"0066": {
      artworkAvailability: "SOLD",
      artworkDescription:
        'Ikea hanging lamp - REGOLIT HEMMA hanging lampshade.  Author\'s modification: orange KOBRA spray, paper, glue\n"ORANGE"',
    },*/

    "0065": {
      artworkAvailability: "AVAILABLE",
      artworkDescription:
        'Lighting project, lamp.\nMade of metal and black plastic mesh. Created on the basis and shaft of a transformed paper lamp from @ikeawnetrza "STORM". Bulbs are mounted on the lamp.',
    },

    "0064": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0063": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0062": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0061": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0060": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0059": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0058": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0057": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },
    /*
    "0056": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },
*/
    "0055": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0054": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0053": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0052": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0051": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0050": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0049": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0048": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0047": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0046": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0045": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0044": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0043": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0042": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0041": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0040": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0039": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0038": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0037": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0036": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0035": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0034": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0033": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0032": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0031": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0030": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0029": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0028": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0027": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0026": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0025": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0024": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0023": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0022": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0021": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0020": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0019": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0018": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0017": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },
    /*
    "0016": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },
*/
    "0015": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0014": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0013": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0012": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0011": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0010": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0009": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0008": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0007": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0006": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0005": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0004": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0003": {
      artworkAvailability: "AVAILABLE",
      artworkDescription: "",
    },

    "0002": {
      artworkAvailability: "SOLD",
      artworkDescription: "",
    },

    "0001": {
      artworkAvailability: "AVAILABLE ",
      artworkDescription: "",
    },

    "0000": {
      artworkAvailability: "",
      artworkDescription: "",
    },
  },

  // EXHIBITIONS
  exhibitions: {
    exhibitionsHeader: "Exhibitions",
    exhibitionsContainer: {
      "0007": {
        exhibitionTitle: 'Exhibition of modern art "BIOART"',
        exhibitionDate: "November 2021 – December 2021",
        exhibitionDescription: "",
      },

      "0006": {
        exhibitionTitle:
          "Exhibition of modern art from the collection of Piotr Fajkis at the Ignacy Mine in the city of Rybnik, Poland",
        exhibitionDate: "January 2020 – February 2020",
        exhibitionDescription:
          "Collection of art by present young and older Polish artists alike, where Michał Król’s piece titled „The Network” was featured.",
      },

      "0005": {
        exhibitionTitle:
          "Jasinski&friends VII – art exhibition at the Gallery „Przy Teatrze Narodowym” in Warsaw",
        exhibitionDate: "November 2019 – January 2020",
        exhibitionDescription:
          "The 7th edition of Jasinski&friends collective art exhibition was organized by Dominik Jasinski in cooperation with the Gallery „Przy Teatrze Narodowym” in Warsaw. There were 26 pieces of polish artists, including paintings, graphics and photography, where three works of Michał Król entitled „Earth Skull”, „Golden Skul” and „Copper Skull” were featured.",
      },

      "0004": {
        exhibitionTitle:
          "Vernisage of „Interior” works at Popart Gallery in Poznan",
        exhibitionDate: "October 2018 – November 2018",
        exhibitionDescription:
          "The X-ray imaging shows what’s invisible to the naked eye: our inner shell, structure, organic matter, as metaphor for the INTERIOR within ourselves, an emotional landscapes illustrated with various colours representing emotional, musical, physical and erotic experiences. It is also a tribute to electronic techno music, which carries a particle of futurism, darkness, modernity as well as technical and rawness like an X-ray machine, which has become a diagnostic tool of artistic creation.",
      },

      "0003": {
        exhibitionTitle:
          "21 st Internation Congress of Environmental Protection Envicon Environment at the MTP Poznań Expo",
        exhibitionDate: "October 2017 – October 2017",
        exhibitionDescription:
          "Congress is a forum for the most important representatives of goverment central and local administration, represetatives of Polish and foreign enterprises, experts in the field of waste management and water waste management, as well as the use of recyclable materials and reasonable environmental and ecological management. As part of the use of recyclable materials and in relation to the ZERO WASTE trend, STRUCTURAL COLLAGE project was featured to show to possibilities of re-using by products of production processes in artistic terms, connecting ART and ZERO WASTE together.",
      },

      "0002": {
        exhibitionTitle:
          "Vernissage STRUCTURAL COLLAGE at Geranium Caffe in Poznań",
        exhibitionDate: "June 2017 – September 2017",
        exhibitionDescription:
          "The vernissage took place in one of the most popular restaurants in Poznań - Geranium Caffe Vege Cousine, presenting artworks that were focusing on the processes of nature in a different context, by showing abstract creations made in interaction of machines with humans.",
      },

      "0001": {
        exhibitionTitle:
          "Exhibition and Happening „STRUCTURAL COLLAGE” in Bydgoszcz",
        exhibitionDate: "March 2017 – May 2017",
        exhibitionDescription:
          "The exhibition took place in the 14th branch of the Provincial and Municipal Public Library in the centre if Bydgoszcz. The projects intention was to reach out to ordinary people and to encourage them to interact with modern art. Visitors were also invited to create a great social library collage: library-art-Street. To achieve this, a huge library window was used, in which distinctive colors were arranged, attempting to draw the attention and encourage people to stop and enjoy the arts.",
      },
    },
  },

  // BIOGRAPHY
  biography: {
    biographyHeader: "About me",
    biographyParagraph:
      "Michał Król was born in 1984 in the region of Kujawy, Poland. He obtained a master's degree in Pedagogy and Psychology at the Kazimierz Wielki University in Bydgoszcz, Poland. His works are currently divided into two categories: STRUCTURAL COLLAGE with the use of industrial machines, which had helped the creation of structural paintings and INTERIOR illustrating the insight into the interior literally as well as figuratively, by utilizing X-Ray and magnetic resonance imaging. His source of inspiration were factories in Bydgoszcz, where he used to work in his free time and while studying. From there, he has begun using and assembling industrial materials in his works. Its characteristic collage and structural painting show that the materials can be re-used and put in a new and unique, lively context. His style is mainly inspired by structuralism and industrialism portraying the beauty of things that are present in our lives. His admiration for the works of Alberto Burri, Piotr Łakomy Andy Warhol and Hans Rudolf Giger inspired him to create his very own „structural collage” and “interior”. He has travelled to many countries, such as Australia, Swtizerland, Germany and Great Britain. Currently, he lives and works in Poznan, Poland.",
    biographyImage: "./images/biography/BiographyImage.jpg",
  },

  // CONTACT
  contact: {
    contactHeader: "Contact",
    contactButton: "Get in touch with me",
    contactData: "Your contact details",
    contactEmail: "Your email address",
    contactMessage: "Message content",
    contactErrorBackUp:
      "An error occurred while sending the message. Please send it directly to",
    contactErrorInvalidEmail: "Invalid email address.",
    contactErrorSending: "Sending...",
    contactSuccessSending: "Message has been sent.",
  },
};
